import loadable from '@loadable/component';

export const not_found = loadable(() => import('./NotFoundPage'));
export const generic = loadable(() => import('./GenericPage'));